import {
  apiClient,
  Auth,
  Pagination,
  PaginationSearchParams,
} from '@/shared/api'
import { getCookie } from '@/shared/lib/server'

import { TRecentViewedRoom } from '../model/schema'

export const getRecentViewedRooms = async () => {
  const uuid = await getCookie('uuid')

  const response = await apiClient.get<TRecentViewedRoom[]>({
    endpoint: `/rooms/recent/view`,
    queryParams: { uuid },
  })

  return response
}

export type RecentViewedRoomsSearchParams = PaginationSearchParams

export const getRecentViewedRoomsWithPagination = async (
  params: RecentViewedRoomsSearchParams,
) => {
  const uuid = await getCookie('uuid')

  const response = await apiClient.get<Pagination<TRecentViewedRoom>>({
    endpoint: `/rooms/recent-views`,
    queryParams: { uuid, ...params, size: 10 },
    auth: Auth.OPTIONAL,
  })

  return response
}
